export class EventConstants {
  static readonly REEL_SPIN_DONE = "REEL_SPIN_DONE";
  static readonly HIDE_FRAMES = "HIDE_FRAMES";
  static readonly OVERLAY_SYMBOLS_RESET = "OVERLAY_SYMBOLS_RESET";
  static readonly GAME_INTRO_COMPLETE = "GAME_INTRO_COMPLETE";
}